import React from 'react';
import { TFunction } from 'i18next';
import Trans from '@lib/components/Trans/Trans';

export default function getPasswordSubtitle(
  passwordUpdatedAt: string | null | undefined,
  t: TFunction,
): React.ReactNode {
  if (!passwordUpdatedAt) {
    return undefined;
  }
  const date = new Date(passwordUpdatedAt);
  const now = new Date();
  const diffDays = Math.floor(
    (now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24),
  );
  if (diffDays === 0) {
    return t('password-last-updated-today');
  }
  if (diffDays === 1) {
    return t('password-last-updated-yesterday');
  }
  return (
    <Trans
      i18nKey="password-last-updated-days-ago"
      values={{ days: diffDays }}
    />
  );
}
